import React, { Component } from "react";
import httprequester from "../../../lib/requester";
import BarcodeReader from "react-barcode-reader";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import ReactTable from "react-table";
import "react-table/react-table.css";

class Scan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: [],
      success: "",
      dataTable: [],
      scannedNumber: 0,
      barcode_scan: "",
      loading: false,
      opendebitur: {},
      disabledScan: false,
      scan_type: 'INV',
      user: JSON.parse(window.localStorage.getItem('is_user'))
    };
  }

  componentDidMount = () => {
    document.getElementById("txt-scan").focus();
    this.getOpen()
  };

  handleKeyDown = (e) => {
    if (
      e.key === "Enter" ||
      e.keyCode === 13 ||
      e.key === "Tab" ||
      e.keyCode === 9
    ) {
      e.preventDefault();

      let value = e.target.value
      console.log('scanning trigger', value)
      this.setState({ barcode_scan: value });
      let app = this
      window.setTimeout(() => {
        app.handleSubmit()
      }, 200)
    }
  };

  getOpen = () => {
    let { user } = this.state
    let url = '/api/collect/v1/opname-debitur/get-open-odeb?org_id=' + user.org_id
    httprequester.getCollect(url, {
      success: function(response) {
        let {data} = response.data
        if (data.header_id) {
          this.setState({ opendebitur: data, snapId: data.snap_id })
          this.getList(data.header_id)
        } else {
          this.setState({ disabledScan: true, error: ['There\'s no active Opname Debitur, Plase Activate it First'] })
        }
      }.bind(this),
      error: function(e) {
        this.setState({ error: [e.message]})
      }.bind(this)
    })
  }

  getList = (header_id) => {
    let { user } = this.state
    let url = '/api/collect/v1/opname-debitur/list?org_id=' + user.org_id + '&header_id=' + header_id
    httprequester.getCollect(url, {
      success: function(response) {
        let { data } = response.data
        this.setState({
          dataTable: data.data,
          scannedNumber: data.total,
        })
      }.bind(this),
      error: function(e) {
        console.log(e)
      }
    })
  }

  showNotification = () => {
    if (this.state.success.length > 0) {
      return (
        <div className="alert alert-success" role="alert">
          <i className="fa fa-check" /> {this.state.success}
        </div>
      );
    } else if (this.state.error.length > 0) {
      return (
        <div className="alert alert-danger" role="alert">
          <ul>
            {this.state.error.map((item, index) => {
              return (
                <li key={index}>
                  <i class="fas fa-exclamation-triangle" /> {item}
                </li>
              );
            })}
          </ul>
        </div>
      );
    }
  };

  handleChangeInput = (e) => {
    let name = e.currentTarget.name;
    let value = e.currentTarget.value;

    document.getElementById("txt-scan").focus();
    this.setState({ [name]: value });
  };

  renderFilter = () => {
    return (
      <div className="row">
        <div className="col-md-6">
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-12">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="scan_type" value="INV" checked={this.state.scan_type === 'INV' ? true : false} onClick={this.handleChangeInput.bind(this)} />
                    <label class="form-check-label" for="inlineRadio1">Invoice</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="scan_type" value="TTF" checked={this.state.scan_type === 'TTF' ? true : false} onClick={this.handleChangeInput.bind(this)} />
                    <label class="form-check-label" for="inlineRadio2">TTF</label>
                  </div>
                </div>
              </div>
              <div className="row mt-3">
                <div className="col-md-8">
                  <input
                    type="text"
                    id="txt-scan"
                    disabled={this.state.disabledScan}
                    className="form form-control"
                    name="barcode_scan"
                    onChange={this.handleChangeInput.bind(this)}
                    value={this.state.barcode_scan}
                    onKeyDown={this.handleKeyDown.bind(this)}
                  />
                </div>
                <div className="col-md-4">
                  <button
                    type="button"
                    className="btn btn-primary btn-block"
                    disabled={this.state.disabledScan}
                    onClick={this.handleSubmit.bind(this)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-md-3">
          <h1>{this.state.scannedNumber}</h1>
          Scanned
        </div>
      </div>
    );
  };

  handleError = (e) => {
    console.log('error handler', e);
  };

  handleScan = (data) => {
    console.log('scanning trigger', data)
    this.setState({ barcode_scan: data });
    let app = this
    window.setTimeout(() => {
      app.handleSubmit()
    }, 200)
  };

  renderInputBarcode = () => {
    return (
      <div>
        <BarcodeReader
          onError={this.handleError}
          onScan={this.handleScan}
        />
      </div>
    );
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "NO",
          accessor: "header_id",
          width: 50,
          Cell: function(row) {
            return (
              <span>{ row.index + 1 }</span>
            )
          }
        },
        {
          Header: 'INVOICE NUMBER',
          accessor: "trx_number",
          filterable: true
        },
        {
          Header: 'TTF NO',
          accessor: "ttf_no",
          filterable: true
        },
        {
          Header: 'SCANNED AT',
          accessor: "time_stamp",
          filterable: true,
          Cell: function(row) {
            let date = row.value ? moment(row.value).format('DD-MMM-YYYY HH:mm:ss') : ''
            return (
              <span>{date}</span>
            )
          }
        },
        {
          Header: 'SCANNED BY',
          accessor: 'created_by_name',
          filterable: true
        }
      ],
      rows: this.state.dataTable,
    };

    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  handleSubmit = () => {
    let { user, barcode_scan, opendebitur, scan_type } = this.state
    let url = "/api/collect/v1/opname-debitur/insert-line";
    let param = {
      trx_number: barcode_scan,
      username: user.username,
      headerId: opendebitur.header_id,
      scan_type: scan_type
    };

    this.setState({ loading: true, disabledScan: true });
    httprequester.postCollect(url, param, {
      success: function (response) {
        this.setState({
          loading: false,
          success:
            response.data.message || "Barcode has been scanned successfully!",
        });
        let app = this;
        window.setTimeout(() => {
          app.setState({ success: '', disabledScan: false, error: [], barcode_scan: "" });
          app.getList(opendebitur.header_id)
          document.getElementById("txt-scan").focus();
        }, 2000);
      }.bind(this),
      error: function (e) {
        this.setState({
          loading: false,
          barcode_scan: "",
          disabledScan: false,
          error: [e.response.data.message || 'Failed to scan, please try again']
        });
        document.getElementById("txt-scan").focus();
      }.bind(this),
    });
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12 col-sx-12">
                <div className="card card-info">
                  <div className="card-body">
                    {this.showNotification()}
                    {this.renderFilter()}
                    {this.renderTable()}
                    {/* {this.renderInputBarcode()} */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Loader fullPage loading={this.state.loading} />
      </div>
    );
  }
}

export default Scan;
